<script>
import TranscriptSummaryPanel from '@modules/crm/components/transcript-summary-panel/transcript-summary-panel.vue'

export default {
  name: 'DetailTabResumo',
  components: { TranscriptSummaryPanel },
  props: {
    summary: { type: Object, default: null },
    aiStatus: { type: String, default: '' },
    transcriptStatus: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    canRegenerate: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div>
    <TranscriptSummaryPanel
      :summary="summary"
      :ai-status="aiStatus"
      :transcript-status="transcriptStatus"
      :loading="loading"
      :can-regenerate="canRegenerate"
      @regenerate="$emit('regenerate')"
    />
  </div>
</template>
